/* eslint-disable import/no-cycle */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import _ from 'lodash';
import axios from 'axios';
import * as TYPES from './action-types';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  dataContentRadioData,
  dataSourceRadioData,
  multiPriceSelectionRadioData,
} from '../utils/constant';
import { ERR_PROCESSING_REQ } from '../../../../SharedModules/AppConstants';
import { getUTCTimeStampMMDDYYYY } from '../../../../SharedModules/DateUtilities/DateUtilities';

export const setRequestPriceLoadLoading = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_LOADING,
    payload,
  };
};

export const setRequestPriceLoadSearchFilter = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_SEARCH_FILTER,
    payload,
  };
};

export const addRowToTableData = (row, key) => {
  return (dispatch, getState) => {
    let currentPriceLoadDetailsTableData = {
      ...getState().sharedState.requestDrugPriceLoad.priceLoadDetailsTableData,
    };
    if (Object.keys(currentPriceLoadDetailsTableData).length > 0) {
      currentPriceLoadDetailsTableData[
        key === multiPriceSelectionRadioData[0].value
          ? 'priceTableData'
          : 'uraTableData'
      ] = [
        row,
        ...currentPriceLoadDetailsTableData[
          key === multiPriceSelectionRadioData[0].value
            ? 'priceTableData'
            : 'uraTableData'
        ],
      ];
    } else {
      currentPriceLoadDetailsTableData[
        key === multiPriceSelectionRadioData[0].value
          ? 'priceTableData'
          : 'uraTableData'
      ] = [row];
    }

    dispatch(setPriceLoadDetailsTableData(currentPriceLoadDetailsTableData));
  };
};

export const updatePriceLoadDetailsTableCell = (rowIndex, colId, value) => {
  return (dispatch, getState) => {
    let currentPriceLoadDetailsTableData = {
      ...getState().sharedState.requestDrugPriceLoad.priceLoadDetailsTableData,
    };
    let filters = {
      ...getState().sharedState.requestDrugPriceLoad.priceLoadDetailsFilter,
    };
    const key =
      filters.multiPriceSelection === multiPriceSelectionRadioData[0].value ||
      filters.dataContent === dataContentRadioData[0].value
        ? 'priceTableData'
        : 'uraTableData';
    if (
      currentPriceLoadDetailsTableData &&
      currentPriceLoadDetailsTableData[key] &&
      currentPriceLoadDetailsTableData[key][rowIndex]
    ) {
      currentPriceLoadDetailsTableData[key][rowIndex][colId] = value;
    }
    dispatch(setPriceLoadDetailsTableData(currentPriceLoadDetailsTableData));
  };
};

export const deleteRowFromData = (row, key) => {
  return (dispatch, getState) => {
    const currentPriceLoadDetailsTableData = {
      ...getState().sharedState.requestDrugPriceLoad.priceLoadDetailsTableData,
    };

    const TableData = [
      ...currentPriceLoadDetailsTableData[
        key === multiPriceSelectionRadioData[0].value
          ? 'priceTableData'
          : 'uraTableData'
      ],
    ];

    if (row.isAddedFromUI) {
      currentPriceLoadDetailsTableData[
        key === multiPriceSelectionRadioData[0].value
          ? 'priceTableData'
          : 'uraTableData'
      ] = TableData.filter((item) => item.index !== row.index);
    } else {
      const findIndex = TableData.findIndex((item) => item.index === row.index);

      currentPriceLoadDetailsTableData[
        key === multiPriceSelectionRadioData[0].value
          ? 'priceTableData'
          : 'uraTableData'
      ][findIndex] = { ...row, deleteRecord: true };
    }

    dispatch(setPriceLoadDetailsTableData(currentPriceLoadDetailsTableData));
  };
};

export const setSearchFilter = (key, value) => {
  return (dispatch, getState) => {
    const currentSearchFilter = {
      ...getState().sharedState.requestDrugPriceLoad.searchFilter,
    };
    currentSearchFilter[key] = value;
    dispatch(setRequestPriceLoadSearchFilter(currentSearchFilter));
  };
};

export const setDefaultQtr = (data) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_DEFAULT_QUATER,
    defaultQtrRDP: data,
  };
};
export const setUserDefault = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_USER_DEFAULT,
    payload,
  };
};

export const setPriceLoadDetailsFilter = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_FILTER,
    payload,
  };
};

export const setPriceLoadDetailsReferenceData = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_REFERENCE_DATA,
    payload,
  };
};

export const setPriceTypeData = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_PRICE_TYPE_DATA,
    payload,
  };
};
export const setRebateProgramData = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_REBATE_PROGRAM_DATA,
    payload,
  };
};
export const setMFGTableData = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_MFG_TABLE_DATA,
    payload,
  };
};
export const setPriceLoadDetailsChanged = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_CHANGED,
    payload,
  };
};

export const uploadSaveDisable = (payload) => ({
  type: TYPES.UPLOAD_SAVE_DISABLE,
  payload,
});

export const setPriceLoadDetailsLoaded = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_TABLEDATA_LOADED,
    payload,
  };
};

export const setPriceLoadDetailsTableData = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_TABLEDATA,
    payload,
  };
};

export const currentCorrLinkID = (payload) => {
  return {
    type: TYPES.CURRENT_CORR_LINK_ID,
    payload,
  };
};

export const setPriceLoadDetailsCompareTableData = (payload) => {
  return {
    type: TYPES.REQUEST_DRUG_PRICE_LOAD_DETAILS_COMPARE_TABLEDATA,
    payload,
  };
};

export const getRequestDrugPriceLoadUserDefaults =
  (logInUser) => async (dispatch) => {
    try {
      const response = await axios.post(
        `${serviceEndPoint.GET_USER_DEFAULTS}?userId=${logInUser}`
      );
      dispatch(setUserDefault((response.data && response.data.data) || null));
    } catch (e) {
      dispatch(setUserDefault(null));
    }
  };

export const getRequestDrugPriceLoadManufactureList =
  (values) => async (dispatch) => {
    if (
      values?.calcQtr !== '' &&
      values?.rpc && 
      (
        values?.dataContent === 'Multiple' ||
        (values?.dataContent === 'Single' && values?.priceType?.length > 0)
      )
    ) {
      dispatch(setRequestPriceLoadLoading(true));
      try {
        const response = await axios.post(
          `${serviceEndPoint.MFG_DRUG_PRICELOAD}`,
          values
        );
        dispatch(setMFGTableData(response.data || []));
      } catch (e) {
        dispatch(setMFGTableData([]));
      }
      dispatch(setRequestPriceLoadLoading(false));
    } else {
      dispatch(setMFGTableData([]));
    }
  };

export const dispatchNewUraRec = (payload) => ({
  type: TYPES.CUSTOM_ADDDATA_URA,
  payload,
});

export const checkTargetQtrIsFuture = (quater, calcQtr) => {
  const targetQtr = quater;
  if (calcQtr) {
    if (targetQtr.split('Q')[1] > calcQtr.split('Q')[1]) {
      return true;
    }
    if (
      targetQtr.split('Q')[1] === calcQtr.split('Q')[1] &&
      targetQtr.split('Q')[0] > calcQtr.split('Q')[0]
    ) {
      return true;
    }
    return false;
  }
  return false;
};

export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};

export const getRequestDrugPriceLoadDetails =
  (values, onSuccess = () => {}, onError = () => {}, save = false) =>
  async (dispatch) => {
    dispatch(setRequestPriceLoadLoading(true));
    try {
      const response = await axios.post(
        `${serviceEndPoint.REQUEST_PRICE_LOAD_DETAILS}`,
        {
          planType: values.planType,
          rpc: values.rpc,
          calcQtr: values.calcQtr,
          dataContent: values.dataContent,
          priceType: values.priceType ? [values.priceType] : ['AMP', 'BP'],
          dataSource: values.dataSource,
          mfgId: values.mfgId,
          labelerCodeList: values?.lablecode,
          priceSelection: 'P',
        }
      );
      if (response.data) {
        const tempObj =
          !save && !response.data.priceVOList.length
            ? [
                {
                  isAddedFromUI: true,
                  price: '0.000000',
                  bestPrice: '0.000000',
                  calcQtr: values.calcQtr,
                  drugCatCd: null,
                  lastUpdateDt: getUTCTimeStampMMDDYYYY(new Date()),
                  // lastUpdateUserId: logInUser,
                  targetQtr: values.calcQtr,
                  labelerCode: values.mfgId,
                  productCode: null,
                  packageSize: null,
                  index: 0,
                  ccCommentsExist: 0,
                  corrLinkId: 'new',
                },
              ]
            : response.data &&
              response.data.priceVOList &&
              response.data.priceVOList.length &&
              response.data.priceVOList.map((item, index) => {
                const obj = { ...item };
                if (obj.bestPrice !== undefined) {
                  obj.bestPrice =
                    (obj.bestPrice && parseFloat(obj.bestPrice).toFixed(6)) ||
                    '0.000000';
                }
                if (obj.calcQtr !== undefined) {
                  obj.calcQtr = obj.calcQtr || null;
                }
                if (obj.targetQtr !== undefined) {
                  obj.targetQtr = obj.targetQtr || null;
                }
                obj.index = index;
                obj.ccCommentsExist = 0;
                obj.price =
                  (obj.price && parseFloat(obj.price).toFixed(6)) || '0.000000';
                return obj;
              });
        let newTempObj=[];
        if (tempObj && tempObj?.length > 0) {
            const result = await getExistingCorrLinkIds({
              corrLinkId: tempObj.map((item) => {
                return item.corrLinkId;
              }),
            });

             newTempObj = tempObj?.map((item) => {
                  if (
                    result &&
                    result.data?.filter((x) => {
                      return x === item.corrLinkId;
                    }).length > 0
                  ) {
                    item.ccCommentsExist = 1;
                  } else {
                    item.ccCommentsExist = 0;
                  }
                  return item;
                });
            }
        if (
          !save &&
          values.dataContent !== 'Single' &&
          !response.data.calculatedUraVOList.length
        )
          dispatch(dispatchNewUraRec(true));
        const requestedData = {
          priceTableData: newTempObj,
          uraTableData:
            response.data &&
            response.data.calculatedUraVOList &&
            response.data.calculatedUraVOList.map((item, index) => {
              const obj = { ...item };
              obj.calcUra =
                (obj.calcUra && parseFloat(obj.calcUra).toFixed(6)) ||
                '0.000000';
              obj.index = index;
              return obj;
            }),
        };
        dispatch(setPriceLoadDetailsTableData(requestedData));
        dispatch(
          setPriceLoadDetailsCompareTableData(_.cloneDeep(requestedData))
        );
        dispatch(setPriceLoadDetailsChanged(false));
        if (values?.dataSource === dataSourceRadioData?.[2]?.value)
          dispatch(uploadSaveDisable(true));
        onSuccess();
      } else {
        onError(ERR_PROCESSING_REQ);
      }
    } catch (e) {
      onError(ERR_PROCESSING_REQ);
    }
    dispatch(setRequestPriceLoadLoading(false));
  };

export const getRequestDrugPriceLoadValidateFrozenInvoice =
  (values, onSuccess, onError) => async (dispatch) => {
    dispatch(setRequestPriceLoadLoading(true));
    try {
      const response = await axios.post(
        `${serviceEndPoint.REQUEST_PRICE_LOAD_VALIDATE_FROZEN_INVOICE}`,
        {
          invQtr: values.calcQtr,
          rebateProgramCd: values.rpc,
          mfgId: values.mfgId,
        }
      );
      onSuccess(response.message || null);
    } catch (e) {
      onError(e?.response?.data?.message || null);
    }
    dispatch(setRequestPriceLoadLoading(false));
  };

export const getRequestDrugPriceLoadFileUpload =
  (values, onSuccess, onError, logInUser) => async (dispatch) => {
    dispatch(setRequestPriceLoadLoading(true));
    try {
      const uploadData = new FormData();
      uploadData.append('file', values.file);
      uploadData.append('userId', logInUser);
      const fetchData = {
        userId: logInUser,
        dataType: values.dataContent,
      };
      const fetchDataConfig = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const response = await axios.post(
        `${serviceEndPoint.REQUEST_PRICE_LOAD_FILE_UPLOAD}`,
        uploadData
      );

      if (response.data) {
        const fetchResponse = await axios.post(
          `${serviceEndPoint.REQUEST_PRICE_LOAD_FILE_READ}`,
          fetchData,
          fetchDataConfig
        );

        if (fetchResponse.data) {
          const requestedData = {
            priceTableData:
              (fetchResponse.data &&
                fetchResponse.data.priceVOList &&
                fetchResponse.data.priceVOList.map((item) => {
                  const obj = { ...item };
                  if (obj.bestPrice !== undefined) {
                    obj.bestPrice =
                      (obj.bestPrice && parseFloat(obj.bestPrice).toFixed(6)) ||
                      '0.000000';
                  }

                  obj.price =
                    (obj.price && parseFloat(obj.price).toFixed(6)) ||
                    '0.000000';
                  return obj;
                })) ||
              [],
            uraTableData:
              (fetchResponse.data &&
                fetchResponse.data.calculatedUraVOList &&
                fetchResponse.data.calculatedUraVOList.map((item, index) => {
                  const obj = { ...item };
                  obj.calcUra =
                    (obj.calcUra && parseFloat(obj.calcUra).toFixed(6)) ||
                    '0.000000';
                  obj.index = index;
                  return obj;
                })) ||
              [],
          };

          dispatch(setPriceLoadDetailsTableData(requestedData));
          dispatch(
            setPriceLoadDetailsCompareTableData(_.cloneDeep(requestedData))
          );
          dispatch(uploadSaveDisable(false));
          dispatch(setPriceLoadDetailsChanged(false));
          dispatch(setPriceLoadDetailsLoaded(true));
          onSuccess();
        } else {
          onError();
        }
      } else {
        onError();
      }
    } catch (e) {
      onError(e?.response?.data?.message);
    }
    dispatch(setRequestPriceLoadLoading(false));
  };

export const getRequestDrugPriceLoadMaxQuarterForFreezeDt = () => {
  return async (dispatch) => {
    try {
      const response = await axios.post(
        `${serviceEndPoint.GET_QUARTER_FOR_CONTRACT}`
      );
      dispatch(
        setDefaultQtr(
          response.data && response.data.data ? response.data.data : null
        )
      );
    } catch (e) {
      dispatch(setDefaultQtr(null));
    }
  };
};

export const getRequestDrugPriceLoadRebateProgramCode =
  (values) => async (dispatch) => {
    try {
      const response = await axios.post(
        `${serviceEndPoint.GET_ALL_REBATE_PROGRAMS}`,
        { planType: values }
      );
      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        const newData = [];
        response.data.data.forEach((item) => {
          newData.push({
            label: `${item.rebateProgramCd} | ${item.shortDescr}`,
            value: item.rebateProgramCd,
          });
        });
        dispatch(setRebateProgramData(newData));
      } else {
        dispatch(setRebateProgramData([]));
      }
    } catch (e) {
      dispatch(setRebateProgramData([]));
    }
  };

export const getReferenceList = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_DROPDOWN}`, values)
    .then((response) => {
      return dispatch(setPriceLoadDetailsReferenceData(response.data));
    })
    .catch(() => {
      dispatch(setPriceLoadDetailsReferenceData(null));
    });
};

export const getRequestDrugPriceLoadPriceTypeDetails = () => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_PRICETYPE_DATA)
    .then((response) => {
      if (
        response.data &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        const newData = [];
        response.data.data.forEach((item) => {
          if (item.allowEntryInd === 1) {
            newData.push({
              label: `${item.longDescr ? `  ${item.longDescr}` : ''}`,
              value: item.priceTypeCd,
              dispSeq: item.dispSeq,
              longDescr: item.longDescr,
            });
          }
        });
        newData.sort((a, b) => a.dispSeq - b.dispSeq);

        dispatch(setPriceTypeData(newData));
      } else {
        dispatch(setPriceTypeData());
      }
    })
    .catch(() => {
      dispatch(setPriceTypeData());
    });
};

/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const savePriceLoadDetails = (
  request,
  getRequestData,
  onSuccess = () => {},
  onError = () => {}
) => {
  return async (dispatch) => {
    dispatch(setRequestPriceLoadLoading(true));
    try {
      const response = await axios.post(
        serviceEndPoint.REQUEST_PRICE_LOAD_DETAILS_SAVE,
        request
      );

      dispatch(
        getRequestDrugPriceLoadDetails(
          getRequestData,
          () => onSuccess(response.data),
          onError,
          true
        )
      );
    } catch (e) {
      onError(e);
    }
    dispatch(setRequestPriceLoadLoading(false));
  };
};

export const validateNDCAvailability = async (values) => {
  try {
    const response = await axios.post(
      serviceEndPoint.REQUEST_PRICE_LOAD_VALIDATE_NDC,
      values
    );

    if (response.data) {
      return response.data.ndcList || [];
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const triggerCommentsExistingCheck = (payload) => {
  return {
    type: TYPES.TRIGER_COMMENTS_EXIST_CHECK,
    payload,
  };
};

export const resetRequestDurgPriceLoadStore = (payload) => {
  const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
  if (
    (payload === '/RequestDrugPriceLoadDetails' &&
      !updateTabs.filter((x) => {
        return x.navTo === '/RequestDrugPriceLoad';
      }).length > 0) ||
    (payload === '/RequestDrugPriceLoad' &&
      !updateTabs.filter((x) => {
        return x.navTo === '/RequestDrugPriceLoadDetails';
      }).length > 0)
  ) {
    return {
      type: TYPES.RESET_REQUEST_DRUG_PRICE_LOAD_STORE,
      payload,
    };
  }
  // Return a valid action object instead of null
  return {
    type: TYPES.RESET_REQUEST_DRUG_PRICE_LOAD_STORE,
    payload: null,
  };
};
